import { ModalLayoutHeader } from './src/ModalLayoutHeader';
import { ModalLayout as _ModalLayout } from './src/ModalLayout';
import { ModalLayoutBody } from './src/ModalLayoutBody';
import { ModalLayoutFooter } from './src/ModalLayoutFooter';
import { ModalLayoutSection } from './src/ModalLayoutSection';

// Object.assign is used for the right typing.
// Based on this solution: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757
export const ModalLayout = Object.assign(_ModalLayout, {
  Header: ModalLayoutHeader,
  Body: ModalLayoutBody,
  Footer: ModalLayoutFooter,
  Section: ModalLayoutSection,
});

export {
  ModalLayoutContext,
  type ModalLayoutContextProps,
} from './src/ModalLayoutContext';
export { type ModalLayoutHeaderProps } from './src/ModalLayoutHeader';
export { type ModalLayoutProps } from './src/ModalLayout';
export { type ModalLayoutSectionProps } from './src/ModalLayoutSection';
